<template>
  <b-modal
    hide-footer
    centered
    :id="'NonLoggedModal'"
    size="lg"
    title-tag="span"
  >
    <button type="button" class="close" slot="modal-header-close" aria-label="Close">
      <span></span>
      <span></span>
    </button>
    <section class="entity-non-logged-modal">
      <div class="container-fluid p-0">
         <div class="bg-white rounded p-5">
            <div class="row flex-column align-items-center my-5">
               <i class="icon icon-info-2 xl mb-5 color-primary"></i>
               <span class="text-18 text-center w-50">{{ translate('rdInOrderToBookWithAPoints') }}</span>
            </div>
            <div class="row mb-4">
               <div class="col-auto mt-5 m-auto d-flex align-items-center">
                  <button class="btn btn-md btn-primary text-uppercase" @click="showLogInModal()"><span>{{ translate('rdSignIn') }}</span></button>
                  <button class="btn btn-md btn-secondary text-uppercase" @click="closeModal()"><span>{{ translate('rdReturnToRooms') }}</span></button>
               </div>
            </div>
         </div>
      </div>
    </section>
  </b-modal>
</template>

<script>

export default {
  name: 'NonLoggedModal',
  methods: {
    closeModal () {
      this.$root.$emit('bv::hide::modal', 'NonLoggedModal')
    },
    showLogInModal () {
      this.closeModal()
      // eslint-disable-next-line no-undef
      $('#modal-rewards-login').modal('show')
    }
  }
}
</script>
